{
  "schema": "tyme.wordpress.knowledge.v1",
  "site_url": "https://cms.example.test/",
  "articles": [
    {
      "id": "10",
      "parent_id": "0",
      "title": "Guest arrival guide",
      "url": "https://cms.example.test/arrival/",
      "categories": [
        "Guest services"
      ],
      "html": "<h2>Welcome and arrival</h2><p>This sample demonstrates how an illustrated WordPress page appears in the agent workspace. Replace it with your property’s approved guidance.</p><figure><img src=\"https://cms.example.test/uploads/lobby.jpg\" alt=\"Sample property image placeholder\"><figcaption>Photos stay next to the instructions they explain.</figcaption></figure><h2>Quick reference</h2><table><thead><tr><th>Topic</th><th>Where to look</th></tr></thead><tbody><tr><td>Parking</td><td>Parking and entrance</td></tr><tr><td>Internet</td><td>Internet and guest support</td></tr></tbody></table><p><a href=\"https://cms.example.test/parking/\">Open the parking guide</a></p>"
    },
    {
      "id": "20",
      "parent_id": "10",
      "title": "Parking and entrance",
      "url": "https://cms.example.test/parking/",
      "categories": [
        "Arrival",
        "FAQ"
      ],
      "html": "<h2>Finding the entrance</h2><p>Sample instructions: confirm the guest’s destination before giving directions.</p><details open><summary>Where should a guest park?</summary><p>Use the property-approved parking instructions. Add a map or entrance photo to this page in WordPress.</p></details><details><summary>What if the entrance is closed?</summary><p>Contact the front desk using the property phone book. Do not guess access codes.</p></details><h2>Before transferring</h2><ul><li>Confirm the property.</li><li>Explain the reason for transfer.</li><li>Record the outcome in the call notes.</li></ul>"
    },
    {
      "id": "30",
      "parent_id": "10",
      "title": "Internet and guest support",
      "url": "https://cms.example.test/internet/",
      "categories": [
        "Connectivity",
        "FAQ"
      ],
      "html": "<h2>Internet help</h2><p>This is sample content. No real network names or credentials are included.</p><ol><li>Ask which device the guest is using.</li><li>Check the property’s current connection instructions.</li><li>Escalate unresolved connectivity issues to the approved contact.</li></ol><h2>Supervisor guidance</h2><p>Keep detailed troubleshooting articles in WordPress and reimport updates using the same source ID.</p>"
    }
  ],
  "media": [
    {
      "url": "https://cms.example.test/uploads/lobby.jpg",
      "path": "media/lobby.jpg"
    }
  ],
  "warnings": []
}
